import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, switchMap } from 'rxjs';

import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import {
  Colors,
  DashboardModes,
  Desktop,
  GetEnumValuesDto,
  LoginPageModes,
} from '../../../../core/api/models';
import { CreateCustomerDomainCommand } from '../../../../core/api/models/create-customer-domain-command';
import { CustomerDomainsService } from '../../../../core/api/services';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { UpdateCustomerDomainCommand } from './../../../../core/api/models/update-customer-domain-command';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { ImageUploaderComponent } from "../../../../shared/components/image-uploader/image-uploader.component";
import { ResellerDomainFieldComponent } from "./reseller-domain-field/reseller-domain-field.component";


@Component({
    selector: 'app-customer-domain-form',
    templateUrl: './domain-form.component.html',
    styleUrls: ['./domain-form.component.scss'],
    imports: [BaseFormModule, ImageUploaderComponent, ResellerDomainFieldComponent]
})
export class CustomerDomainFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  domainInfoForm!: FormGroup;
  chooseTemplateForm!: FormGroup;
  chooseThemeForm!: FormGroup;
  currentStep: number;
  isShowAlertDetailsInManualMode: boolean = true;
  maxMobileNumbersInManualMode = 10000;
  newResellerDomains: string[] = [];
  resellerDomainForm: FormGroup[] = [];
  protected currentService = inject(CustomerDomainsService);

  fields = 'pages.customerDomains.form.fields.';
  model: CreateCustomerDomainCommand = {};
  loginPageModeImg: any = [
    {
      name: LoginPageModes.RightLogin,
      src: '/assets/media/login-page-mode/right-login.png',
      alt: 'right login',
    },
    {
      name: LoginPageModes.CenterLogin,
      src: '/assets/media/login-page-mode/center-login.png',
      alt: 'center login',
    },
    {
      name: LoginPageModes.LoginWithCarousel,
      src: '/assets/media/login-page-mode/login-with-carousel.png',
      alt: 'login with carousel',
    },
  ];

  @Input() LoginPageModesEnum: GetEnumValuesDto[] = [];

  get Desktop() {
    return Desktop;
  }
  get DashboardModes() {
    return DashboardModes;
  }

  get LoginPageModes() {
    return LoginPageModes;
  }

  get Colors() {
    return Colors;
  }

  //#endregion

  constructor(

    protected http: HttpClient
  ) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.initForm();

      if (!this.model.sliderPicturePaths?.length)
        this.model.sliderPicturePaths = [''];
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  initModel(): void {
    try {
      super.initModel();
      if (this.formPageConfig?.isEditMode) {
        this.newResellerDomains = Object.assign([], this.model.resellerDomain);
      } else {
        this.newResellerDomains = [];
        this.onAddResellerDomain();
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  onAddResellerDomain() {
    try {
      this.newResellerDomains.push('');
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  initForm() {
    this.domainInfoForm = new FormGroup({
      resellerName: new FormControl('', Validators.required),
      resellerIdentityDomain: new FormControl('', [Validators.required]),
      resellerLink: new FormControl(''),
      eNamad: new FormControl(''),
    });

    this.chooseTemplateForm = new FormGroup({
      desktop: new FormControl('', Validators.required),
    });

    this.form = new FormGroup({
      dashboardMode: new FormControl(''),
      primaryColor: new FormControl(''),
      secondaryColor: new FormControl(''),
    });
  }

  get errorControl() {
    return this.form.controls;
  }

  //#region Api

  //Create
  baseCreateApi(model: CreateCustomerDomainCommand) {
    this.unSubs();

    this.loading = true;

    this.model.sliderPicturePaths = this.model?.sliderPicturePaths.filter(
      (item) => item.trim() !== ''
    );

    this.currentService
      .customerDomainsCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateCustomerDomainCommand) {
    this.unSubs();

    this.model.sliderPicturePaths = this.model?.sliderPicturePaths.filter(
      (item) => item.trim() !== ''
    );

    this.loading = true;
    this.currentService
      .customerDomainsUpdatePut({ id: model.id, body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  // In this method, the type of login page is selected
  onSelectLoginPageMode(loginPageMode) {
    this.model.loginPageMode = loginPageMode;
  }

  // get current step
  onChangeStep(event) {
    this.currentStep = event.selectedIndex;
  }

  //#region Slider Picture

  addSliderPicture(imgSrc: string) {
    this.model.sliderPicturePaths.push(imgSrc);

    this.model.sliderPicturePaths = this.model.sliderPicturePaths.filter(
      (item) => item !== ''
    );
  }

  addImageUploaderField() {
    this.model.sliderPicturePaths.push('');
  }

  deleteImageUploaderField(index: number) {
    this.model.sliderPicturePaths.splice(index, 1);
    this.model.sliderPicturePaths = this.model?.sliderPicturePaths.filter(
      (item) => item !== undefined
    );

    if (!this.model.sliderPicturePaths?.length)
      this.model.sliderPicturePaths = [''];
  }

  //#endregion

  // convert Blob to Base64 for pishgam logo
  convertBlobToBase64(blob: Blob) {
    return Observable.create((observer) => {
      const reader = new FileReader();
      const binaryString = reader.readAsDataURL(blob);
      reader.onload = (event: any) => {
        observer.next(event.target.result);
        observer.complete();
      };

      reader.onerror = (event: any) => {
        observer.next(event.target.error.code);
        observer.complete();
      };
    });
  }

  onChangeAlertDetailsInManualMode(event) {
    const timeOut = setTimeout(() => {
      this.isShowAlertDetailsInManualMode = event.hasAttribute('open');
      clearTimeout(timeOut);
    }, 20);
  }

  onSubmit() {
    if (this.loading) return;
    if (!this.isValidForm(this.form, this.tagName)) return;
    if (!this.isValidResellerDomainForms()) return;

    try {
      if (this.model.resellerLink == '') this.model.resellerLink = undefined;
      this.model.resellerDomain = this.newResellerDomains;

      // When a logo is not uploaded, pishgam logo will be uploaded and displayed by default
      if (!this.model?.logoSrc) {
        this.http
          .get('../../../../../assets/media/logos/logo.png', {
            responseType: 'blob',
          })
          .pipe(switchMap((blob) => this.convertBlobToBase64(blob)))
          .subscribe((base64ImageUrl) => {
            this.model.logoSrc = base64ImageUrl as string;
            this.checkCreateOrUpdate();
          });
      } else this.checkCreateOrUpdate();
    } catch (error) {
      ConsoleService.error('error', error);
      this.loggerService.logError(this.tagName, error, EventTypes.baseFormPage);
    }
  }

  //#region reseller domain

  onRemoveResellerDomain(index: number) {
    try {
      if (
        this.newResellerDomains.length > 1 ||
        this.formPageConfig?.isEditMode
      ) {
        this.newResellerDomains.splice(index, 1);
        this.resellerDomainForm.splice(index, 1);
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  isValidResellerDomainForms(): boolean {
    try {
      let result: boolean = true;
      this.resellerDomainForm.forEach((form) => {
        if (form.invalid) {
          result = false;
          form.markAllAsTouched();
        }
      });

      return result;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  //#endregion
}
